import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type JobCreateWindowState = {
  isOpen: boolean;
  modalKey: string | null;
  companyId: string | number | null;
  step: number | null;
  quoteMode: string | null;
  hasHydrated: boolean;
  openWindow: (modalKey: string, companyId?: string | number | null) => void;
  setWindowState: (payload: { step: number; quoteMode?: string | null; companyId?: string | number | null }) => void;
  clearWindow: () => void;
  setHasHydrated: (hasHydrated: boolean) => void;
};

export const useJobCreateWindowStore = create<JobCreateWindowState>()(
  persist(
    (set) => ({
      isOpen: false,
      modalKey: null,
      companyId: null,
      step: null,
      quoteMode: null,
      hasHydrated: false,
      openWindow: (modalKey, companyId = null) => set({ isOpen: true, modalKey, companyId }),
      setWindowState: ({ step, quoteMode, companyId }) =>
        set((state) => ({
          step,
          quoteMode: quoteMode ?? null,
          companyId: companyId ?? state.companyId,
        })),
      clearWindow: () => set({ isOpen: false, modalKey: null, companyId: null, step: null, quoteMode: null }),
      setHasHydrated: (hasHydrated) => set({ hasHydrated }),
    }),
    {
      name: "job-create-window",
      storage: createJSONStorage(() => localStorage),
      partialize: ({ isOpen, modalKey, companyId, step, quoteMode }) => ({
        isOpen,
        modalKey,
        companyId,
        step,
        quoteMode,
      }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    },
  ),
);
